import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Trash2, Users } from "lucide-react";

// value: array of { name, age }. onChange: (array) => void
export const GuestListEditor = ({ value, onChange, testid, hideHeader = false }) => {
  const list = Array.isArray(value) ? value : [];

  const update = (i, key, val) => {
    const next = list.map((g, idx) => (idx === i ? { ...g, [key]: val } : g));
    onChange(next);
  };
  const add = () => onChange([...list, { name: "", age: "" }]);
  const remove = (i) => onChange(list.filter((_, idx) => idx !== i));

  return (
    <div data-testid={testid}>
      {!hideHeader && (
        <div className="mb-3 flex items-center gap-2">
          <Users className="h-4 w-4 text-[#E0575B]" />
          <h3 className="font-display text-sm font-700 tracking-tight text-zinc-200">Guest List</h3>
          <span className="text-xs text-zinc-400">— imported from the sheet ({list.length})</span>
        </div>
      )}

      <div className="space-y-2">
        {list.map((g, i) => (
          <div key={i} className="flex items-center gap-2" data-testid={`guest-list-row-${i}`}>
            <Input
              value={g.name ?? ""}
              onChange={(e) => update(i, "name", e.target.value)}
              placeholder="Name"
              className="flex-1 border-zinc-800 bg-zinc-900 focus-visible:ring-[#E0575B]/70"
              data-testid={`guest-list-name-${i}`}
            />
            <Input
              value={g.age ?? ""}
              onChange={(e) => update(i, "age", e.target.value)}
              placeholder="Age"
              className="w-20 border-zinc-800 bg-zinc-900 focus-visible:ring-[#E0575B]/70"
              data-testid={`guest-list-age-${i}`}
            />
            <button
              type="button"
              onClick={() => remove(i)}
              className="rounded p-2 text-zinc-400 hover:bg-red-500/10 hover:text-red-400"
              data-testid={`guest-list-remove-${i}`}
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={add}
        className="mt-2 border-zinc-700 bg-transparent hover:bg-zinc-800"
        data-testid="guest-list-add"
      >
        <Plus className="mr-1.5 h-4 w-4" /> Add guest
      </Button>
    </div>
  );
};
